var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('iframe',{attrs:{"id":"mapPage","width":"100VW","height":"100VH","frameborder":"0","src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }